document.addEventListener('DOMContentLoaded', function () {
  
  // Helper function for debouncing API calls
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Function to fetch the updated cart via Shopify's AJAX API
  function fetchCartDataAndUpdateProgressBar() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
          
         const cartTotal = cart.total_price / 100; // Convert from cents to pounds
         const progressBar = document.querySelector(".progress-bar");
         const progressText = document.getElementById("progress-text");
      
          if (!progressBar || !progressText) return;

        var checkmarkIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" style="width: 20px; height: 20px; vertical-align: middle; margin-right: 5px;">
                <circle cx="12" cy="12" r="12" fill="#44a83e"/>
                <polyline points="16 8 10 14 8 12" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

        var packageIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 20px; height: 20px; vertical-align: middle; margin-right: 5px;">
              <path d="M21 16V8a2 2 0 0 0-1-1.73L12 2 4 6.27A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l8 4.55 8-4.55A2 2 0 0 0 21 16z"></path>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
              <line x1="12" y1="22.08" x2="12" y2="12"></line>
            </svg>`;

        // Update progress bar width based on cart total
        const progressPercentage = Math.min((cartTotal / 40) * 100, 100);
        progressBar.style.width = progressPercentage + "%";
      
        // Update progress message
        let message = "";
        if (cartTotal === 0) {
            message = packageIcon + " FREE Shipping on £40+ Orders";
        } else if (cartTotal < 40) {
            const amountLeft = (40 - cartTotal).toFixed(2);
            message = packageIcon + ` Add £${amountLeft} and get FREE Shipping`;
        } else {
            message = checkmarkIcon + " Enjoy FREE Shipping!";
        }
      
        progressText.innerHTML = message;
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  // Initial progress bar update on page load
  fetchCartDataAndUpdateProgressBar();

  // Debounced function to reduce rapid API calls
  const debouncedUpdateProgressBar = debounce(fetchCartDataAndUpdateProgressBar, 500);

  // Function to re-attach event listeners after cart changes
  function attachEventListeners() {
    var quantityButtons = document.querySelectorAll('.quantity__button');
    quantityButtons.forEach(function(button) {
      button.addEventListener('click', function () {
        setTimeout(debouncedUpdateProgressBar, 500);
      });
    });

    var removeButtons = document.querySelectorAll('cart-remove-button');
    removeButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        setTimeout(debouncedUpdateProgressBar, 500);
      });
    });
  }

  // Attach event listeners on page load
  attachEventListeners();

  // Re-attach event listeners on DOM changes (e.g., after AJAX updates)
  const observer = new MutationObserver(function () {
    attachEventListeners();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // For drawer type cart
  const drawerObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.classList.contains('drawer') && mutation.target.classList.contains('active')) {
        fetchCartDataAndUpdateProgressBar();
      }
    });
  });

  const drawer = document.querySelector('.drawer');
  if (drawer) {
    drawerObserver.observe(drawer, { attributes: true });
  }

});
